import { render, staticRenderFns } from "./SanctionInformation.vue?vue&type=template&id=0f81640e&scoped=true"
import script from "./SanctionInformation.vue?vue&type=script&lang=js"
export * from "./SanctionInformation.vue?vue&type=script&lang=js"
import style0 from "./SanctionInformation.vue?vue&type=style&index=0&id=0f81640e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81640e",
  null
  
)

export default component.exports